mutation TravelerUrgentUpdate($input: TravelerUrgentUpdateInput!) {
  travelerUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
